'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-05-14
 */
import _ from 'lodash'

export function validationService () {
	// 12-32 characters, and must contain at least one letter, one digit and
	// one non-alphanumeric character - mirrors janux-persist's
	// DEFAULT_PASSWORD_POLICY (server/config/default.js deliberately has no
	// passwordPolicy override, so that's what the server actually enforces
	// here - JAM-25). A password manager's default generated output already
	// satisfies this. `.` excludes newlines, which is fine: nothing
	// legitimate types one into a password field. This is a hard-coded copy
	// of the server's rule, not fetched from it - keep in sync if either
	// changes.
	const isPassword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{12,32}$/
	const isEmail = /^(([^<>()[\]\\.,:\s@"]+(\.[^<>()[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

	const service = {
		/**
		 * Validates password strength and match against confirmation if required
		 * @param password The password
		 * @param confirm Optional password confirmation
		 * @returns true if everything is ok or throw error string code
		 */
		password: (password, confirm) => {
			// Check password confirmation
			if (!_.isNil(confirm)) {
				if (password !== confirm) {
					throw new Error('notMatch')
				}
			}
			// Check password strength
			if (!isPassword.test(password)) {
				throw new Error('strength')
			}
			return true
		},

		/**
		 * Validates if the email address meets the format or not
		 * @param email The email address
		 * @returns {boolean} indicating whether the email is valid or not
		 */
		email: (email) => {
			return (isEmail.test(email))
		},

		/**
		 *
		 * @param emails
		 * @return {boolean} return false only if any of the emails is invalid, otherwise return true
		 */
		everyEmailAddress: (emails) => {
			if (!_.isNil(emails) && emails.length > 0) {
				// E24-37: `this` here used to be undefined -- arrow
				// functions don't bind their own `this`, and this factory
				// is called as a plain function, not a method. Reference
				// the `service` object directly instead.
				var validEmailCallback = (email) => {
					return service.email(email.address)
				}
				return _.every(emails, validEmailCallback)
			}
			return true
		},

		isEmail: isEmail
	}

	return service
}



// WEBPACK FOOTER //
// ./src/common/services/validation-service.js